<template>
  <div class="ydrz-wrap">
    <div class="ydrz-left">
      <div class="ydrz-title">信息检索</div>
      <div class="ydrz-item">
        <div class="ydrz-name">姓名</div>
        <input type="text" />
      </div>
      <div class="ydrz-item">
        <div class="ydrz-name">姓名</div>
        <input type="text" />
      </div>
      <div class="ydrz-item">
        <div class="ydrz-name">姓名</div>
        <input type="text" />
      </div>
      <div class="ydrz-item">
        <div class="ydrz-name">姓名</div>
        <input type="text" />
      </div>
      <div class="ydrz-item">
        <div class="ydrz-name">姓名</div>
        <input type="text" />
      </div>
      <div class="ydrz-item">
        <div class="ydrz-name">姓名</div>
        <input type="text" />
      </div>
      <div class="ydrz-button">
        <div>确定</div>
      </div>
    </div>
    <div class="ydrz-right">
      <div class="ydrz-item2">
        <div class="ydrz-item2-top">
            <div class="ydrz-item2-top1">
                <div>姓名：xxxx</div>
                <div>电话：xxxx</div>
                <div>房型：xxxx</div>
                <div>保留时间：xxxx</div>
                <div>订单来源：xxxx</div>
                <div>订单号：xxxx</div>
                <div>入住时间：xxxx</div>
                <div>离店时间：xxxx</div>
            </div>
            <div class="ydrz-item2-top2">
                <div>2020-09-27：229元</div>
                <div>2020-09-27：229元</div>
                <div>2020-09-27：229元</div>
                <div>2020-09-27：229元</div>
                <div>2020-09-27：229元</div>
                <div>2020-09-27：229元</div>
                <div>2020-09-27：229元</div>
            </div>
        </div>
        <div class="ydrz-item2-foot">登记入住</div>
      </div>
      

      <div class="ydrz-item2">
        <div class="ydrz-item2-top"></div>
        <div class="ydrz-item2-foot">登记入住</div>
      </div>
      <div class="ydrz-item2">
        <div class="ydrz-item2-top"></div>
        <div class="ydrz-item2-foot">登记入住</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.ydrz-wrap {
  padding: 3.5%;
  width: 100%;
  height: 100%;
  display: flex;
}
.ydrz-left {
  width: 23%;
  height: 100%;
  margin-right: 2%;
  box-shadow: 4px 4px 10px #b1c9f1, -4px -4px 10px #ffffff;
  border-radius: 8px;
  padding: 1% 1.2%;
}
.ydrz-title {
  font-size: 1em;
  color: #2c3036;
  margin-bottom: 6%;
}
.ydrz-item {
  height: 12.5%;
}
.ydrz-name {
  color: #575f6b;
  font-size: 0.8em;
  margin-bottom: 2%;
}
input {
  border: 1px solid #76a8f5;
  outline: none;
  box-shadow: 2px 2px 4px #b1c9f1 inset, -2px -2px 4px #ffffff inset;
  height: 1.8em;
  border-radius: 3px;
  padding-left: 10px;
  width: 100%;
  color: #575f6b;
  font-size: 0.8em;
}
.ydrz-button {
  margin-top: 10%;
  height: 7%;
  display: flex;
  justify-content: center;
}
.ydrz-button > div {
  width: 55%;
  height: 100%;
  color: #575f6b;
  font-size: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 4px 4px 10px #b1c9f1, -4px -4px 10px #ffffff;
  border-radius: 8px;
}
.ydrz-right {
  width: 75%;
  height: 100%;
  box-shadow: 4px 4px 10px #b1c9f1, -4px -4px 10px #ffffff;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  padding: 2%;
}
.ydrz-item2 {
  width: 48%;
  height: 42%;
  /* background: cornflowerblue; */
  margin-right: 2%;
  margin-bottom: 2%;
}
.ydrz-item2-top {
  background: url(../assets/image/ydrz-pg.png);
  background-size: 100% 100%;
  height: 90%;
  width: 100%;
  padding:3% 4.2%
}
.ydrz-item2-top1{
    height:61.5%;
    display: flex;
    flex-wrap: wrap;
}
.ydrz-item2-top1 div{
    min-width:30%;
    margin-right:3%;
    font-size:0.6em;
    color:#6D798E;
    line-height:1.8em
    
}
.ydrz-item2-top2{
    height:38.5%;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    padding-top:3%;
}
.ydrz-item2-top2 div{

    min-width:47%;
    margin-right:3%;
    font-size:0.6em;
    color:#6D798E;
    line-height:2em
    
}
.ydrz-item2-foot {
  width: 100%;
  height: 20%;
  box-shadow: 2px 2px 4px #b1c9f1, -2px -2px 4px #ffffff;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color:#575F6B;
  font-size:0.6em
}
</style>